import { Schedule } from "./Schedule";

export enum CheckInValidationType {
    COUNT = "count_check_in_validator",
    PURCHASE_CUTOFF = "purchase_cutoff_check_in_validator",
    FIRST_CHECK_IN_CUTOFF = "first_check_in_cutoff_check_in_validator",
    SCHEDULE = "schedule_check_in_validator",
}

export enum Availability {
    AVAILABLE = "available",
    UNAVAILABLE = "unavailable",
}

interface BaseCheckInValidation {
    id?: ID;
    object: CheckInValidationType;
}

export interface CheckInValidationCount extends BaseCheckInValidation {
    object: CheckInValidationType.COUNT;
    max: number;
}

export interface CutoffCheckInValidation extends BaseCheckInValidation {
    duration: string; // ISO 8601 (P2DT30)
    availability: Availability;
}

export interface FirstCheckInCutoffCheckInValidation extends CutoffCheckInValidation {
    object: CheckInValidationType.FIRST_CHECK_IN_CUTOFF;
}

export interface PurchaseCutoffCheckInValidation extends CutoffCheckInValidation {
    name?: string;
    object: CheckInValidationType.PURCHASE_CUTOFF;
}

export interface ScheduleCheckInValidation extends BaseCheckInValidation {
    object: CheckInValidationType.SCHEDULE;
    schedule: Schedule;
}

interface CheckInValidationMap {
    [CheckInValidationType.COUNT]: CheckInValidationCount;
    [CheckInValidationType.PURCHASE_CUTOFF]: PurchaseCutoffCheckInValidation;
    [CheckInValidationType.FIRST_CHECK_IN_CUTOFF]: FirstCheckInCutoffCheckInValidation;
    [CheckInValidationType.SCHEDULE]: ScheduleCheckInValidation;
}

type AllCheckInValidation =
    | CheckInValidationCount
    | FirstCheckInCutoffCheckInValidation
    | PurchaseCutoffCheckInValidation
    | ScheduleCheckInValidation;

export type CheckInValidation<T = CheckInValidationType> = T extends keyof CheckInValidationMap
    ? CheckInValidationMap[T]
    : AllCheckInValidation;

export interface CheckInPreference {
    enabled: boolean;
    validations: CheckInValidation[];
}
